import { StoreWebSocket } from '@xsolla/store-websocket';

import type { StoreBlock } from '@site-builder/common/src/types/blocks';
import type { Authorization } from '@site-builder/common/src/types/model/landing';

import { ScriptsState } from '../../../reducers/modules/site-builder/scripts';
import { UserAccountIdService } from '../user-account-services/user-account-id-service';
import { UserAccountService } from '../user-account-services/user-account-service';
import { UniversalCart } from './cart/UniversalCart';
import { handleFetchingAndRenderingSections } from './handle-sections';
import { setupSectionCardsHandlers } from './setup-section-cards-handlers';

interface LoadStoreProps {
  data: ScriptsState;
  block: HTMLDivElement;
  blockStructure: StoreBlock;
  enableCart: boolean;
  auth: Authorization;
  cart: UniversalCart;
  storeAPIDataService: any;
  userService: UserAccountService;
  inventory: any;
}

export const loadStore = async ({
  data,
  block,
  blockStructure,
  enableCart,
  auth,
  cart,
  storeAPIDataService,
  userService,
  inventory,
}: LoadStoreProps): Promise<void> => {
  const { userToken } = userService;
  const buttons = await handleFetchingAndRenderingSections({
    block,
    storeAPIDataService,
    blockStructure,
    enableCart,
    userToken,
  });

  if (enableCart) {
    await cart.load();
  }

  if (userService.isAuthorized) {
    inventory.load();
  }

  setupSectionCardsHandlers({ buttons, data, block, auth, userToken });
};

export const createSocket = async (props: LoadStoreProps) => {
  const { userService } = props;
  if (userService.isAuthorized && userService instanceof UserAccountIdService) {
    const socket = new StoreWebSocket({
      user_external_id: userService.userId,
    });
    socket.onerror = () => {
      socket.close();
    };
    socket.onopen = () => {
      // To prevent the directory from being reloaded, from old events
      setTimeout(() => {
        socket.onmessage = async (data) => {
          if (data.status === 'done') {
            await loadStore(props);
          }
        };
      }, 1000);
    };
    socket.connect();
  }
};
